"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _HotelRoomOffersSkeleton["default"];
  }
});
var _HotelRoomOffersSkeleton = _interopRequireDefault(require("./HotelRoomOffersSkeleton"));